exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table__child-row[data-v-52457305] {\n  cursor: pointer;\n}\n.table__child-row-toggle[data-v-52457305] {\n  transition: transform .3s ease-in-out;\n}\n.table__child-row-toggle--open[data-v-52457305] {\n  transform: rotate(90deg);\n  transition: transform .3s ease-in-out;\n}\n.message__details[data-v-52457305]:not(:first-child) {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid rgba(0, 0, 0, .1);\n}\n", ""]);

// exports
